module.exports = __webpack_public_path__ + "static/img/3234_phase_function_Paper_Points.f9983b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3234_phase_function_Paper_Points.png
// module id = gZYs
// module chunks = 0